module.exports = __webpack_public_path__ + "img/legend-hr.0f38fc01.svg";